import countryCodeList from './list/countryCode';
import currencyList from './list/currency';
import offerCode from './list/offerCode';

/**
 * Binding avec les offres de livraison
 * @param  {String} name Nom de l'offre
 * @return {String}      Label de l'offre de livraison à afficher
 */
export const getOfferCode = name =>
  offerCode.find(element => element.name === name);

export const requiredCompanyName = code => {
  const offer = offerCode.find(element => element.value === code);
  if (offer && offer.requiredCompanyName) {
    return true;
  }
  return false;
};

export const requiredPickupPointId = code => {
  const offer = offerCode.find(element => element.value === code);
  if (offer && offer.requiredPickupPointId) {
    return true;
  }
  return false;
};

export const getCountryCode = code => {
  const countryCode = countryCodeList.find(
    element =>
      element.label.toLowerCase() === code.toLowerCase() ||
      element.englishLabel.toLowerCase() === code.toLowerCase() ||
      element.value.toLowerCase() === code.toLowerCase()
  );
  if (countryCode) {
    return countryCode.value;
  }
  return false;
};

export const isEuCountry = code => {
  const country = countryCodeList.find(element => element.value === code);
  if (country) {
    return country.isUeCountry;
  }
  return false;
};

export const getCurrency = currencyCode => {
  const currency = currencyList.find(element => element.value === currencyCode);
  if (currency) {
    return currency.value;
  }
  return null;
};

export const isArmyPost = postalCode =>
  postalCode ? postalCode.includes('00100') || postalCode.includes('00200') : false;
/**
 * Vérifie si le code postal fait partie des drom (département et territoire d'outre mer)
 * @param  {String}  postalCode [description]
 * @return {Boolean}            [description]
 */
export const isDromPostCode = postalCode =>
  postalCode ? postalCode.replace(/\s/g, '').substring(0, 2) > 96 : false;
